import React, { useEffect, useState } from "react";
import axios from "axios";
import JuryLiveAuditionCard from "./JuryLiveAuditionCard";
import AllDataHeader from "../../../Reuseable/AllDataHeader";
import LoaderPost from "../../../Reuseable/LoaderPost";
const LiveAudition = () => {
  const [events, setEvents] = useState([]);
  const [isMyGroupPrimary, setIsMyGroupPrimary] = useState(false);
  const [buffer, setBuffer] = useState(true);
  useEffect(() => {
    axios.get("/api/jury/audition/lives").then((res) => {
      setBuffer(false);
      if (res.data.status === 200) {
        setEvents(res.data.events);
        setIsMyGroupPrimary(res.data.is_my_group_primary);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader title="Live Auditions" count={"Zero"} />

      {buffer ? (
        <LoaderPost />
      ) : (
        <JuryLiveAuditionCard
          data={events}
          isMyGroupPrimary={isMyGroupPrimary}
          videoAssessmentPrimary={`/jury-board/video-assessment-as-primary-group`}
          videoAssessmentLive={`/jury-board/live-audition-video-assessment`}
        />
      )}
    </>
  );
};

export default LiveAudition;
